import { Permission } from '@account-users/account/models/Permission';

export enum ToggleType {
  None = 'none',
  MarketingAutomationSending = 'ma_email',
  EmailBulkSending = 'bulk_email',
  TransactionalEmailSending = 'transactional_email',
}

export interface Toggle {
  text: string;
  type: ToggleType;
  visible: boolean;
  permission?: Permission;
}
